// src/pages/NotFound/index.jsx
import React from 'react';
import { Layout, Result, Button } from 'antd';
import HeaderComponent from '../../components/Header';
import FooterComponent from '../../components/Footer';
import { Link } from 'react-router-dom';
import './index.css';

const { Content } = Layout;

const NotFound = ({ loggedInUser, onLogout }) => {
    return (
        <Layout className="blog-layout">
            <HeaderComponent loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="blog-content notfound-content">
                <Result
                    status="404"
                    title="404"
                    subTitle="抱歉，您访问的页面不存在。"
                    extra={
                        <Link to="/">
                            <Button type="primary">返回首页</Button>
                        </Link>
                    }
                />
            </Content>
            <FooterComponent />
        </Layout>
    );
};

export default NotFound;